<template>
  <svg
    class="play-arrow-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="26"
    viewBox="0 0 21 26"
    fill="none"
  >
    <path d="M0.666504 25.8334V0.166687L20.8332 13L0.666504 25.8334Z" />
  </svg>
</template>

<script>
export default {
  name: "PlayArrowIcon",
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.play-arrow-icon {
  path {
    fill: $aisea-blue;
  }
}
</style>
